"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const react_1 = __importStar(require("react"));
const base_react_components_1 = require("@navinc/base-react-components");
const styled_components_1 = __importDefault(require("styled-components"));
const clone_valid_element_1 = require("../../utils/clone-valid-element");
const StyledStandardCard = (0, styled_components_1.default)(base_react_components_1.StandardCard).withConfig({ displayName: "reports-StyledStandardCard", componentId: "reports-1kfb2nw" }) `
  padding-left: 0;
  padding-right: 0;

  & > :first-child {
    margin-top: -16px;
  }

  & > :last-child {
    margin-bottom: -16px;
  }
`;
const StyledDivider = (0, styled_components_1.default)(base_react_components_1.Divider).withConfig({ displayName: "reports-StyledDivider", componentId: "reports-h53lqg" }) `
  border-radius: 0;
`;
const Menu = ({ currentLocation, children, }) => {
    var _a, _b, _c, _d;
    const [selectedIndex, setIsSelected] = (0, react_1.useState)(0);
    const validChildren = (_c = (_b = (_a = react_1.default.Children) === null || _a === void 0 ? void 0 : _a.toArray(children)) === null || _b === void 0 ? void 0 : _b.filter((child) => child)) !== null && _c !== void 0 ? _c : [];
    const childrenCount = (_d = validChildren === null || validChildren === void 0 ? void 0 : validChildren.length) !== null && _d !== void 0 ? _d : 0;
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement(StyledStandardCard, null, react_1.default.Children.map(validChildren, (child, index) => (react_1.default.createElement(react_1.Fragment, { key: `sidebar-menu-${index}` },
            (0, clone_valid_element_1.cloneValidElement)(child, {
                isSelected: index === selectedIndex,
                setIsSelected,
                index,
                currentLocation,
            }),
            index + 1 !== childrenCount && react_1.default.createElement(StyledDivider, null)))))));
};
exports.Menu = Menu;
exports.Menu.displayName = 'Menu';
exports.default = exports.Menu;
//# sourceMappingURL=menu.js.map